import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { v4 as uuidV4 } from 'uuid';

import ExamResumeCard from '../ExamResumeCard/ExamResumeCard';
import ExamResumeChart from '../ExamResumeChart/ExamResumeChart';

import translate from '../../libs/i18n';
import { examPerformanceNumbersShape } from '../../utils/propTypesShapes';

import { ExamSummaryStyle } from './ExamSummaryStyle';

const ExamSummary = ({ radiographies, tomographies }) => {
  const language = useSelector((state) => state.settings.language);

  const [page, setPage] = useState(0);

  const pageAmout = useMemo(() => {
    let current = 0;

    current += radiographies ? 2 : 0;
    current += tomographies ? 2 : 0;

    return current;
  }, [radiographies, tomographies]);

  const renderNavigation = useMemo(() => {
    const navigationItemButton = [];
    for (let index = 0; index < pageAmout; index += 1) {
      navigationItemButton.push(
        <li
          key={uuidV4()}
          className={`sumary-navigation-item${page === index ? ' active' : ''}`}
        >
          <button
            type="button"
            className="navigation-item-button"
            onClick={() => setPage(index)}
            disabled={page === index}
          >
            <span className="item-button-bullet" />
          </button>
        </li>
      );
    }

    return <ul className="exam-summary-navigation">{navigationItemButton}</ul>;
  }, [page, pageAmout]);

  return (
    <ExamSummaryStyle>
      <h2 className="exam-summary-title">{translate('dashboard', language)}</h2>
      <div className="exam-summary-content">
        {radiographies && tomographies ? (
          <div className="exam-summary-item">
            <div
              className="item-card-wrapper"
              style={{ transform: `translateX(${-100 * page}%)` }}
            >
              <ExamResumeChart
                title={translate('performance', language)}
                radiographies={radiographies}
                tomographies={tomographies}
              />
            </div>
          </div>
        ) : null}

        {tomographies ? (
          <div className="exam-summary-item">
            <div
              className="item-card-wrapper"
              style={{ transform: `translateX(${-100 * page}%)` }}
            >
              <ExamResumeCard
                resume={tomographies}
                title={`${translate(
                  'totalExamsResults',
                  language
                )} - ${translate('tomographies', language)}`}
              />
            </div>
          </div>
        ) : null}

        {radiographies ? (
          <div className="exam-summary-item active">
            <div
              className="item-card-wrapper"
              style={{ transform: `translateX(${-100 * page}%)` }}
            >
              <ExamResumeCard
                resume={radiographies}
                title={`${translate(
                  'totalExamsResults',
                  language
                )} - ${translate('radiographies', language)}`}
              />
            </div>
          </div>
        ) : null}
      </div>
      {renderNavigation}
    </ExamSummaryStyle>
  );
};

ExamSummary.propTypes = {
  radiographies: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    examPerformanceNumbersShape,
  ]),
  tomographies: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    examPerformanceNumbersShape,
  ]),
};

ExamSummary.defaultProps = {
  radiographies: null,
  tomographies: null,
};

export default ExamSummary;
